
































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import YcColorPicker from "@/components/color-picker/index.js";
import {PopSettingsVO, TFormSaveDetailRequest} from "@/model/FormWheel";
import {
  fontFaceList,
  rgbaBackgroundPredefineColors,
} from '../../../constant/options';
import {
  getIconImageList
} from "@/services/api";
import { getCompanyInfo } from "@/model/CompanyInfo";
import { getFontFaceList } from "@/utils/getFontFaceList";
import { getVueAppUploadApi } from "@/services/util";
import { preparePopupImageUpload } from "@/utils/popupImageCompression";
import { FontField, ColorField, FontSizeField } from "@/components/popup-ui/controls";
import { BIG_WHEEL_TPLID, isEnableIconCapabilityOptimize } from "@/utils/experiment";
import OptimizationHint from "@/views/wheelOfFortune/pop/optimizer/components/OptimizationHint.vue";
import { evaluateIcon } from "@/views/wheelOfFortune/pop/optimizer/strategies";
import { reportFormOptimizerEvent } from "@/views/wheelOfFortune/pop/optimizer/tracking";
import { guardFormOptimizerApply, RUNNING_AB_OPTIMIZER_TIP } from "@/views/wheelOfFortune/pop/optimizer/applyGuard";
import {
  ICON_CLOSE_SIZE_OPTIONS,
  ICON_CLOSE_POSITION_OPTIONS,
  DEFAULT_ICON_CLOSE_COLOR,
  DEFAULT_ICON_CLOSE_BG_COLOR,
  getSquareIconWidth,
  resolveDisplayIconCloseSize,
  resolveIconClosePosition,
} from "@/utils/iconPackUp";

@Component({
  components: {
    "yc-color-picker": YcColorPicker,
    "font-field": FontField,
    "color-field": ColorField,
    "font-size-field": FontSizeField,
    OptimizationHint,
  },
})
export default class wheelOfFortuneTextPackUp extends Vue {
  @Prop(String)
  activePageSetting!: string;

  @Prop(Object)
  formData!: PopSettingsVO;

  @Prop(Number)
  triggerEventType!: number;

  @Prop({ type: Boolean, default: false })
  optimizerReadOnly!: boolean;

  imageDialogVisible = false;
  selectImageUrl: string = '';
  imageList: { id: number, imageName: string, imageUrl: string }[] = [];

  formDataStart: any = this.formData
  iconRecommendationDismissed = false
  iconImpressionReported = false
  get optimizerReadOnlyTip() {
    return this.$tx('form.ab.runningNoEdit', RUNNING_AB_OPTIMIZER_TIP);
  }

  get iconRecommendation() {
    return evaluateIcon(this.formDataStart?.settings?.position);
  }

  get showIconRecommendation() {
    return !!this.iconRecommendation && !this.iconRecommendationDismissed;
  }

  reportIconImpression() {
    const recommendation = this.iconRecommendation;
    if (!recommendation || this.iconImpressionReported) return;
    this.iconImpressionReported = true;
    reportFormOptimizerEvent('form_optimizer_recommendation_impression', recommendation.strategyId, recommendation.evidenceVersion);
  }

  applyIconRecommendation() {
    const recommendation = this.iconRecommendation;
    if (!recommendation) return;
    if (!guardFormOptimizerApply(this.optimizerReadOnly, message => this.$message.warning(message))) return;
    this.$set(this.formDataStart.settings.position, 'iconShow', true);
    this.iconRecommendationDismissed = true;
    this.changeStart();
    reportFormOptimizerEvent('form_optimizer_recommendation_applied', recommendation.strategyId, recommendation.evidenceVersion, {
      changed_field_keys: ['settings.position.iconShow'],
    });
  }

  dismissIconRecommendation() {
    const recommendation = this.iconRecommendation;
    if (!recommendation) return;
    this.iconRecommendationDismissed = true;
    reportFormOptimizerEvent('form_optimizer_recommendation_dismissed', recommendation.strategyId, recommendation.evidenceVersion);
  }

  imgNameArr = [
    { imgName: 'left_top_', top: '20px', left: '20px' },
    { imgName: 'right_top_', top: '20px', right: '20px' },
    { imgName: 'left_center_', top: '47%', left: '20px' },
    { imgName: 'right_center_', top: '47%', right: '20px' },
    { imgName: 'left_bottom_', bottom: '20px', left: '20px' },
    { imgName: 'right_bottom_', bottom: '20px', right: '20px' }
  ]
  imgNameObjArr = [
    "LeftTop", "RightTop", "LeftMiddle", "RightMiddle", "LeftBottom", "RightBottom"
  ]
  get iconSizeOption() {
    return [
      { label: this.$tx('form.edit.field.sizeS', '小'), value: 'Small' },
      { label: this.$tx('form.edit.field.sizeM', '中'), value: 'Medium' },
      { label: this.$tx('form.edit.field.sizeL', '大'), value: 'Big' },
    ];
  }
  iconClosePositionOptions = ICON_CLOSE_POSITION_OPTIONS
  iconCloseSizeOptions = [...ICON_CLOSE_SIZE_OPTIONS]
  defaultIconCloseColor = DEFAULT_ICON_CLOSE_COLOR
  defaultIconCloseBgColor = DEFAULT_ICON_CLOSE_BG_COLOR
  /** 含透明预设，对齐 CloseButtonSetting / rgbaBackgroundPredefineColors */
  iconClosePredefineColors = rgbaBackgroundPredefineColors

  selectImgVis = 1

  bannerImgNameArr = ['banner_top_', 'banner_bottom_']

  selectBannerImgVis = 1

  uploadUrl = getVueAppUploadApi() + "/upload/formImage";

  uploadShow = false;

  uploadFileList: { name: string, url: string }[] = [];

  uploadDialogVisible = false;

  uploadDialogUrl = '';

  get token() {
    return localStorage.getItem("token") || "default";
  }

  get companyIs450() {
    // 方法不再调用，全量打开加购悬浮窗
    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}').id;
    return companyId === 450 || companyId === 30 || companyId === 313 || companyId === 721 || companyId === 583 || companyId === 608;
  }

  get companyis535() {
    const status = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id === 535
    return status;
  }

  get enableFormOptimize() {
    return true;
  }

  get enableSubscribeDifferentPage() {
    return this.formDataStart.successPageType === 1;
  }

  get enableIconBeforeShowConfig() {
    const tid = `${Number(this.$route.query.templateid) || this.formData.templateId}`;
    return ![...BIG_WHEEL_TPLID].includes(tid) && this.triggerEventType === 0;
  }

  /** 收起 icon 新能力灰度：未命中时不展示新配置，避免影响线上 */
  get enableIconCapabilityOptimize() {
    return isEnableIconCapabilityOptimize();
  }

  /** 关闭按钮位置展示值：未配置时按 icon 左右侧取线上默认 */
  get displayIconClosePosition() {
    const position = this.formDataStart?.settings?.position || {};
    return resolveIconClosePosition(position.position, position.iconClosePosition);
  }

  /** 优先用户配置；缺省/新建默认 16 */
  get displayIconCloseSize() {
    const position = this.formDataStart?.settings?.position || {};
    const boxW = Number(position.iconWidth) || getSquareIconWidth(position.iconSizeType);
    return resolveDisplayIconCloseSize(position, boxW, this.iconCloseSizeOptions);
  }

  predefineColors = [
    '#ff4500',
    '#ff8c00',
    '#ffd700',
    '#90ee90',
    '#00ced1',
    '#1e90ff',
    '#c71585',
    '#f1b859',
    '#f4994b',
    '#d7394d',
    '#dd5b46',
    '#f7d69e',
  ]

  fontFaceList = getFontFaceList(fontFaceList);

  activeNames = 1
  handleChange(){}

  handleSelectIcon() {
    // console.log(this.selectImageUrl);
    if (this.selectImageUrl) {
      this.formDataStart?.settings?.position && (this.formDataStart.settings.position.iconUrl = this.selectImageUrl);
      this.uploadFileList = [{
        name: '',
        url: this.selectImageUrl
      }];
    }
    this.imageDialogVisible = false;
    // console.log('handleSelectIcon');
  }

  openFloatBanner() {
    if(!this.formDataStart.settings.rules.couponCodeShow || !this.formData.settings.rules.couponCodePosition){
      this.formDataStart.settings.banner.floatBannerShow = false
      this.$message({
        message: this.$tx('form.edit.err.needCoupon', '需开启展示Coupon功能才可使用'),
        type: 'warning'
      });
    } else {
      this.$forceUpdate();
      this.$emit('change',this.formDataStart)
    }
    window?.gtagClick('form_tool_collapseFloatBar','弹窗_编辑订阅工具_收起_修改code浮条')
  }
  openBanner(){
    if(!this.formDataStart.settings.rules.couponCodeShow || !this.formData.settings.rules.couponCodePosition){
      this.formDataStart.settings.banner.bannerShow = false
      this.$message({
        message: this.$tx('form.edit.err.needCoupon', '需开启展示Coupon功能才可使用'),
        type: 'warning'
      });
    }
    window?.gtagClick('form_tool_collapseBanner','弹窗_编辑订阅工具_收起_修改横幅')
  }

  countDownChange() {
    if (this.formDataStart.settings.banner.countDownNum < 1) {
      this.formDataStart.settings.banner.countDownNum = 1;
    } else if (this.formDataStart.settings.banner.countDownNum > 60) {
      this.formDataStart.settings.banner.countDownNum = 60;
    }
    this.changeStart();
  }

  created() {
    if (this.formDataStart.settings.position.iconSizeType) {
      this.formDataStart.settings.position.iconWidth = getSquareIconWidth(
        this.formDataStart.settings.position.iconSizeType
      );
    }

    // https://u60z777w08.feishu.cn/docx/BfE5dvNA9omAQPx5j7vcxlMtnTc 需求，默认为true
    if (this.formDataStart?.settings?.rules?.couponCodeShow === true && !!this.formDataStart.settings.rules.couponCodePosition && this.formDataStart?.settings?.banner?.floatBannerShow === undefined) {
      if (this.triggerEventType === 1 || this.triggerEventType === 2 || this.triggerEventType === 3 || this.triggerEventType === 5 || this.triggerEventType === 6) {
        // 浮条的开启，前置条件coupon展示必须也要开启；浮条可以单独开启关闭；coupon展示关闭，浮条则关闭
        this.formDataStart.settings.banner.floatBannerShow = true;
      }
    }

    this.formDataStart.settings.position.iconSizeType = this.formDataStart.settings.position.iconSizeType ?? 'Medium'
    this.formDataStart.settings.position.iconShow = Boolean(this.formDataStart.settings.position.iconShow)  ?? true
    this.formDataStart.settings.position.iconTiming = this.formDataStart.settings.position.iconTiming ?? 'after'
    this.$nextTick(() => this.reportIconImpression())
    
    if (this.formData.settings.position.iconUrl) {
      this.uploadShow = true
      this.uploadFileList = [
        {
          name: '',
          url: this.formData.settings.position.iconUrl,
        }
      ]
    }
    this.selectImgVis = this.imgNameObjArr.indexOf(this.formData.settings.position.position) + 1

    if(this.formDataStart.settings.banner.position == 'top'){
      this.selectBannerImgVis = 1
    }else{
      this.selectBannerImgVis = 2
    }

    // 确保iconExcludePages是数组
    if (!this.formDataStart.settings.targeting.iconExcludePages) {
      this.$set(this.formDataStart.settings.targeting, 'iconExcludePages', []);
    }

    // 请求icon列表
    getIconImageList({}).then((res: any) => {
      this.imageList = res.data.data;
    });

    this.$forceUpdate();
    this.$emit('change',this.formDataStart)
  }


  /**
   * 图片上传失败钩子函数
   */
  handleError(e: any): void {
    this.uploadShow = false;
    this.$message.warning(this.$tx('form.edit.err.uploadFail', '图片上传失败！'));
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert(this.$tx('form.edit.err.loginExpired', '登录失效，请重新登录'));
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect='+ encodeURIComponent(this.$router.currentRoute.fullPath)
    }
    this.changeStart()
  }

  changeIconCustom() {
    if (this.formDataStart.settings.position.iconCustom) {
      const isMiddle = ['LeftMiddle', 'RightMiddle'].includes(this.formDataStart.settings.position.position);
      const isTop = ['LeftTop', 'RightTop'].includes(this.formDataStart.settings.position.position);
      if (!isTop) {
        this.formDataStart.settings.position.iconCustomBottom = isMiddle ? 50 : 100;
      }
      this.formDataStart.settings.position.iconCustomBottomUnit = isMiddle ? '%' : 'px';
    } else {
      this.formDataStart.settings.position.iconCustomBottom = undefined;
      this.formDataStart.settings.position.iconCustomBottomUnit = undefined;
    }
    this.reportIconCustomClick();
    this.changeStart()
  }

  // icon 可关闭
  changeIconClose(val: boolean) {
    this.formDataStart.settings.position.iconClose = val;
    this.changeStart();
  }

  changeIconFitMode(val: 'square' | 'original') {
    this.setIconPositionField('iconFitMode', val);
  }

  changeIconClosePosition(val: string) {
    this.setIconPositionField('iconClosePosition', val);
  }

  changeIconCloseStyle(val: 'outside' | 'inside') {
    this.setIconPositionField('iconCloseStyle', val);
  }

  changeIconCloseSize(val: number) {
    this.setIconPositionField('iconCloseSize', val);
  }

  changeIconCloseColor(val: string) {
    this.setIconPositionField('iconCloseColor', val);
  }

  changeIconCloseBgColor(val: string) {
    this.setIconPositionField('iconCloseBgColor', val);
  }

  setIconPositionField(key: string, val: any) {
    this.$set(this.formDataStart.settings.position, key, val);
    this.changeStart();
  }

  reportIconCustomClick() {
    window?.gtagClick('form_edit_setIcon_spacing','弹窗_编辑订阅工具_设置icon_间距设置');
  }

  /**
   * icon图片切换
   */
  selectImgClick(index: number) {
    this.formDataStart?.settings?.position && (
      this.formDataStart.settings.position.position = ['LeftTop', 'RightTop', 'LeftMiddle', 'RightMiddle', 'LeftBottom', 'RightBottom'][index]
    );
    this.selectImgVis = index + 1
    this.$emit('change',this.formDataStart)
  }

  /**
   * banner图片切换
   */
  selectBannerImgClick(index: number){
    this.formDataStart.settings.banner.position = ['top', 'bottom'][index]
    this.selectBannerImgVis = index + 1
    this.$emit('change',this.formDataStart)
  }

  /**
   * 图片上传成功钩子函数
   */
  handleSuccess(
    res: { data: { url: string, message:string }[] },
    file: any,
    fileList: any
  ): void {
    this.uploadShow = true;

    if(res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.position && (this.formDataStart.settings.position.iconUrl = res.data[0].url);
      this.uploadFileList = res.data[0].url ? [{name: '', url: res.data[0].url}]: []
      this.$forceUpdate()
    } else {
      fileList.splice(0, fileList.length);
      this.uploadShow = false;
      this.$message.warning(this.$failMsg(res.data[0].message));
    }

    this.changeStart()

  }

  /**
   * 图片上传前钩子函数
   */
  beforeUpload(file: File): Promise<File | Blob | boolean> {
    return preparePopupImageUpload(
      file,
      this.$message,
      () => { this.uploadShow = true; },
      () => { this.uploadShow = !!this.formDataStart?.settings?.position?.iconUrl; },
    );
  }
  /**
   * 删除图片
   */
  uploadUrlDelete() {
    this.uploadShow = false;
    this.formDataStart?.settings?.position && (this.formDataStart.settings.position.iconUrl = '');
  }
  uploadUrlPreview(file: any) {
    this.uploadDialogUrl = file.url;
    this.uploadDialogVisible = true;
  }


  changeStart() {
    this.formDataStart.settings.position.iconWidth = getSquareIconWidth(
      this.formDataStart.settings.position.iconSizeType
    );
    this.$forceUpdate();
    this.$emit('change',this.formDataStart)
  }
  @Watch('formDataStart.settings.position.iconShow')
  iconShowWatch(value: boolean, previous: boolean) {
    if (value === false && previous !== false) {
      this.iconRecommendationDismissed = false;
      this.iconImpressionReported = false;
      this.$nextTick(() => this.reportIconImpression());
    }
    if (value === true) {
      this.iconImpressionReported = false;
    }
  }
  @Watch('formData.settings.position.position')
  positionChange(){
    // console.log(this.imgNameObjArr.indexOf(this.formData.settings.position.position) +1)
    this.selectImgVis = this.imgNameObjArr.indexOf(this.formData.settings.position.position) +1
  }

  validateNumberInput() {
    try {
      const newVal = parseInt(this.formDataStart.settings.position.iconCustomBottom.toString().replace(/[^\d]/g, ''), 10)
      // 兼容element input 数字0校验异常
      this.formDataStart.settings.position.iconCustomBottom = newVal === 0 ? '0' : newVal;
    } catch (error) {
      console.log('validateNumberInput error', error);
    }
    this.changeStart();
  }

}
